import { Component, OnInit, HostListener } from '@angular/core';
import { CustomService } from '../../services/custom.service';
import { AppManagementService } from '../../services/app-management.service';
import { AppTexts } from '../../objects/app-static-texts';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  pageDesignFlag: boolean =false;
  pageDesign: any;
  redirectButton:boolean = false;

  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;
  
  constructor(
    public appDesignService: AppManagementService,
    public customService: CustomService
  ) {  }

  ngOnInit() {
    this.pageDesign = this.appDesignService.getPageDesign();
    
    if(this.pageDesign!=undefined){
      this.pageDesignFlag = true;
      //SENDING PAGE VIEW FOR GA
      this.customService.sendPageViewUpdate(this.pageDesign.name);
      this.pageDesign["style"] = this.appDesignService.applyElementStyle(this.pageDesign);
      this.appDesignService.addToScreenHistory(this.pageDesign.name,"page");
      
      //IF PAGE DESIGN HAVE CUSTOM CODE
      if(this.pageDesign.custom_code !=undefined){
          
        //DECODE BASE64 CUSTOM CODE TO STRING
        this.htmlText = atob(this.pageDesign.custom_code); 
        this.customDesign = true;
        var start=0;
        var end=0;
        
        for(let i = 0; i < this.htmlText.length; i++){
          if(this.htmlText[i]+""+this.htmlText[i+1] == "{{") { start = i+2 }
          if(this.htmlText[i]+""+this.htmlText[i+1] == "}}") { end = i; }

          if(start-end<0){
            var c = this.htmlText.substring(start,end);
            var value = '';  
            for(var e=0;e<this.pageDesign.element_flow.length;e++){
              if(this.pageDesign.element_flow[e].element_keyname == c){
                switch(this.pageDesign.element_flow[e].element_keyname) {
                  case 'screen_image_1':
                    value = this.customService.imageUrl;
                    break;
                  default:
                    value = this.pageDesign.element_flow[e].text;
                }
              }
            }

            this.htmlText = this.htmlText.replace("{{"+c+"}}",value);
            start = end = 0;
          }
        }

        setTimeout(() => {
          if(document.getElementById("loading")!=undefined){
            if(document.getElementById("next_button")!=undefined){
              document.getElementById("loading").setAttribute("style","display:none");
              document.getElementById("next_button").setAttribute("style","display:block");
            }
          }
        }, 2000);
      }
      
      //NORMAL ELEMENT FLOWS STACK LIST
      if(this.pageDesign.element_flow!=undefined){ 
        // ADDING STYLE TO EACH ELEMENT IN THE PAGE
        for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
          if(this.pageDesign.element_flow[t].type == 'custom'){
            this.pageDesign.element_flow[t].custom_html = atob(this.pageDesign.element_flow[t].custom_code);
          }
          else{
            this.pageDesign.element_flow[t]["style"] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[t]);
          }
        }      
      } 

      this.checkForPreviousServerUpdated();
      
      setTimeout(() => { this.updateIframeHeight(); }, 300);
      this.captureImageLoadEvent();
    }
    else{
      this.appDesignService.redirectAppToBase();
    }
    
  }

  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }

  checkForPreviousServerUpdated(){
    
    // IF SERVER UPDATE HAPPENED BEFORE
    if(!this.customService.server_updated_flag){
      
      this.customService.saveToServer().subscribe(
        (data: {}) => {
          if(data!=undefined){
            this.initLoadChecks();
            this.customService.server_response_recieved = true;
            
            this.customService.setServerResponse(data);
          }
        }, (error: {}) => {
          this.customService.server_updated_flag = false;
          console.log('error : ', error);
          // // this.appDesignService.scrollToTop();
          this.updateIframeHeight();
          this.appDesignService.sentEventData(
            AppTexts.clickEventName,
            AppTexts.ButtonCategory,
            AppTexts.ClickAction,
            'Submit Quiz',0);
        }
    
      );
    }
    else{
      this.initLoadChecks();
    }
  }

  initLoadChecks(){
    
    this.redirectButton = true;
    // Load screen without any action
    if(this.pageDesign.auto_trigger !=undefined){
      
      switch (this.pageDesign.auto_trigger.function_name) {
        case 'close':
          this.redirectButton = false;
          this.customService.generateRedirectURL(true);
          break;
        default:
          break;
      }

    }
    
    if(this.pageDesign.custom_code_enabled){
      if(document.getElementById('loading')!=undefined){
        document.getElementById('loading').setAttribute("style","display:none");
      }
      if(document.getElementById('close_button')!=undefined){
        document.getElementById('close_button').setAttribute("style","display:block");
      }
    }
    
    // // this.appDesignService.scrollToTop();
    this.updateIframeHeight();
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {    
    if(this.pageDesign.custom_code !=undefined){
      for(var e=0;e<this.pageDesign.element_flow.length;e++){
        if(this.pageDesign.element_flow[e].element_keyname == event.target.id){
          this.customService.triggerFunction(this.pageDesign.element_flow[e])
        }
      }
    }
  }

  @HostListener('window:keyup', ['$event']) keyUp(e: KeyboardEvent) {
    switch (e.code) {
      case 'Enter': {
        var elements = this.pageDesign.element_flow;
        if(elements!=undefined){
          for(var ele=0; ele<elements.length; ele++){
            if(elements[ele].type==AppTexts.button){
              this.checkForPreviousServerUpdated();
            }
          }
        }
        break;
      }
      default: { break; }
    }
  }

  triggerKeyboardEvent(el: any, keyString: string) {
  
    var eventObj = document.createEvent("Events") as any;
    if(eventObj.initEvent) { eventObj.initEvent("keyup", true, true); }
    eventObj.shiftKey = true;
    eventObj.ctrlKey = false;
    eventObj.metaKey = false;
    eventObj.altKey = false;
    eventObj.key = keyString;
    el.dispatchEvent ? 
    el.dispatchEvent(eventObj) : 
    el.fireEvent("onkeyup", eventObj); 
    
  } 

  press(keyString: string) { this.triggerKeyboardEvent(window, keyString); }
  
  ngAfterViewChecked() { this.updateIframeHeight(); }

  ngDoCheck() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }

  updateIframeHeight() {
    if(this.pageDesign!=undefined){
      var ele = document.getElementById(this.pageDesign.name);
      if(ele!=null && ele!=undefined){
        this.appDesignService.sentHeight(ele.offsetHeight);
      }
    }
  }

}
